import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";

declare let $: any;
declare let defaultGridEditSettings: any;

@Component({
  selector: "account",
  templateUrl: "./account.component.html",
  styleUrls: ["./account.component.css"],
})
export class AccountBranch {
  constructor(private route: ActivatedRoute, private titleService: Title) {}

  ngOnInit() {
    $(document).ready(function () {
      var sourceAccountGroups = {
        datatype: "json",
        datafields: [
          {
            name: "accountGroupCode",
          },
          {
            name: "name",
          },
        ],
        url: "/ajax/account-groups",
        type: "GET",
        async: true,
      };

      var dataAdapterAccountGroups = new $.jqx.dataAdapter(sourceAccountGroups);

      var source = {
        datatype: "json",
        datafields: [
          {
            name: "accountId",
            type: "number",
          },
          {
            name: "code",
            type: "string",
          },
          {
            name: "externalAccountId",
            type: "string",
          },
          {
            name: "displayName",
            type: "string",
          },
          {
            name: "externalAccountGroupId",
            type: "string",
          },
          {
            name: "baseCurrency",
            type: "string",
          },
        ],
        id: "accountId",
        url: "/ajax/accounts",
        type: "GET",
        async: true,
      };

      var settings = defaultGridEditSettings("#jqxgrid", source);
      settings.columns = [
        {
          text: "accountId",
          datafield: "accountId",
          hidden: true,
        },
        {
          text: "Account",
          columntype: "textbox",
          datafield: "code",
          width: "15%",
        },
        {
          text: "External Account Id",
          columntype: "textbox",
          datafield: "externalAccountId",
          width: "15%",
        },
        {
          text: "Account Name",
          columntype: "textbox",
          datafield: "displayName",
          width: "15%",
        },
        {
          text: "Account Group",
          columntype: "dropdownlist",
          datafield: "externalAccountGroupId",
          width: "30%",
          createeditor: function (row, cellvalue, editor) {
            editor.jqxDropDownList({
              source: dataAdapterAccountGroups,
              displayMember: "accountGroupCode",
              valueMember: "name",
            });
          },
        },
        {
          text: "Base Ccy",
          columntype: "dropdownlist",
          datafield: "baseCurrency",
          width: "15%",
          createeditor: function (row, cellvalue, editor) {
            editor.jqxDropDownList({
              source: [
                "AUD",
                "CAD",
                "CHF",
                "DKK",
                "EUR",
                "GBP",
                "HKD",
                "INR",
                "JPY",
                "KRW",
                "MXN",
                "NOK",
                "NZD",
                "RUB",
                "SEK",
                "SGD",
                "USD",
                "ZAR",
              ],
            });
          },
        },
      ];

      $("#jqxgrid").jqxGrid(settings);
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/account/account.component.ts